import React from 'react'
import Show from 'services/Show';
import Expert from 'services/Expert';

import { handleErrors, formatDate } from 'services/utils'
import { Spinner } from 'components/atoms';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';

export default class ShowExpertSortBreeds extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      show: {},
      expert: {},
      breeds: [],
      showId: match.params.id,
      expertId: match.params.expertId,
      successSave: false,
    }
    this.mounted = false;
    this.changed = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    const showPromise = Show.get(this.state.showId).then(show => {
      if (this.mounted) {
        this.setState({ show });
      }
    }).catch((request) => {
      handleErrors(request);
    });
    const expertPromise = Expert.withShowBreeds(this.state.expertId, this.state.showId).then( expert => {
      if (this.mounted) {
        this.setState( { expert, breeds: [...expert.breeds] } );
      }
    });
    expertPromise.catch((request) => {
      handleErrors(request);
    });
    Promise.all([showPromise, expertPromise]).then(()=> {
      if (this.mounted) {
        this.setState({ loading: false });
      }
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  saveChanges = (e) => {
    e.preventDefault();
    const sortedBreedIds = this.state.breeds.map(breed => breed.id);
    const originalBreedIds = this.state.expert.breeds.map(breed => breed.id);
    const changed = sortedBreedIds.some((sortedBid, index) => sortedBid !== originalBreedIds[index])
    if (!changed) {
      alert("Изменения не найдены.");
      return;
    }
    this.setState({ successSave: false, busy: true });
    const expert = this.state.expert;
    expert.sortedBreedIds = sortedBreedIds;
    expert.showId = this.state.show.id;
    expert.saveSortedBreedIds().then((expert) => {
      if (!this.mounted) return; 
      this.setState({ 
        successSave: true, 
        busy: false,
        expert,
        breeds: expert.breeds, 
      });
      this.changed = false;
    }).catch((request) => {
      this.setState({busy: false});
      handleErrors(request);
    });
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    this.changed = true;
    this.setState(({breeds}) => ({
      breeds: arrayMoveImmutable(breeds, oldIndex, newIndex),
    }));
  }

  render() {
    const {show, expert, breeds, loading} = this.state;
    let showInfo = null;
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }

    // const breedsList = expert && expert.breeds ? (expert.breeds || []).map(breed => {
    //   return <li key={breed.id} id={'breed-'+breed.id} className="list-group-item">
    //           ({breed.order}) - {breed.name}
    //          </li>
    // }) : null;

    return (
      <div className="container-fluid">
        <h4>{showInfo}</h4>
        <h5>Породы эксперта {expert.name} ( {expert.country_name} )</h5>
        
        { this.state.successSave && 
         <div className="row alert alert-success">
          Изменения успешно сохранены.
         </div>}

        {loading && <Spinner /> }

        
        <SortableList items={breeds} onSortEnd={this.onSortEnd} />
        
        <div className="row">
          <div className="col-md-12 m-3">
            <button type="button" onClick={this.saveChanges} disabled={this.state.busy || !this.changed} className="btn btn-primary me-2">
              { this.state.busy && <Spinner /> }
              Сохранить
            </button>
            <button type="button" onClick={this.onCancel} disabled={this.state.busy} className="btn btn-light">
              { this.state.busy && <Spinner /> }
              Назад
            </button>
          </div>
        </div>

      </div>
    );
  }
}


const SortableItem = SortableElement(({value}) => <li className="list-group-item">{value.name}</li>);

const SortableList = SortableContainer(({items}) => {
  return (
    <ol className="list-group col-xl-6 col-lg-12 sortable-list">
      {items.map((item, index) => (
        <SortableItem key={`item-${item.id}`} index={index} value={item} />
      ))}
    </ol>
  );
});
